<template>
  <div>
    <v-container
      fluid
      class="mx-12 py-10 d-flex flex-column justify-start main-container"
    >
      <div class="card-label d-flex flex-row mb-4">
        <v-icon>mdi-account-lock</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Admin</p>
      </div>
      <v-form>
        <v-select
          v-model="user"
          :items="
            lessors.filter((l) =>
              l.text.toLowerCase().includes(searchLessorsList.toLowerCase())
            )
          "
          label="Select Lessor"
          solo
          dense
          flat
          @change="getProperty"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple>
              <v-list-item-content>
                <v-text-field
                  v-model="searchLessorsList"
                  outlined
                  dense
                  hide-details
                  placeholder="Search Lessor"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-form>
      <v-card v-if="user && user.username" class="my-1" elevation="0">
        <div class="ma-5 caption">
          <p>Username: {{ user.username }}</p>
          <p>Email: {{ user.email1 }}</p>
          <p>Contact: {{ user.contactNumber1 }}</p>
          <p>User Type: {{ user.userType }}</p>
          <p>Unit Limit: {{ user.unitLimit }}</p>
          <p>Property Limit: {{ user.propertyLimit }}</p>
          <p>Status: {{ user.status }}</p>
          <p>Subscription Start: {{ parseDate(user.subscriptionStart) }}</p>
          <p>Subscription End: {{ parseDate(user.subscriptionEnd) }}</p>
          <v-btn depressed color="primary" @click="activateUserDialog"
            >Update User</v-btn
          >
        </div>
      </v-card>

      <div v-if="selectedProperties.length">
        <v-card elevation="0" class="my-1">
          <v-list two-line>
            <v-list-item
              v-for="item in selectedProperties"
              :key="item.propertyName"
              @click="propertyDialog(item)"
            >
              <v-list-item-avatar>
                <v-img :src="item.logo || ''"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-text="
                    `${item.propertyName} - ${getRoleInProperty(item, user)}`
                  "
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="
                    parseSubscriptionPeriod(
                      item.subscriptionStart,
                      item.subscriptionEnd
                    )
                  "
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </div>

      <v-text-field
        id="emails"
        v-model="lessorsEmail"
        flat
        solo
        dense
        readonly
        append-icon="mdi-content-copy"
        class="mt-4"
        hint="Copy all lessors email here"
        persistent-hint
        @click:append="copyEmail"
      >
      </v-text-field>
    </v-container>

    <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
      <v-card>
        <p class="subtitle-1 font-weight-bold px-10 pt-8 mb-0">
          Approve/Update Property
        </p>
        <v-container class="px-10">
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="6">
              <v-menu
                v-model="selectedProperty.startDateMenu"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedProperty.startDate"
                    hide-details
                    label="Start Date"
                    v-bind="attrs"
                    readonly
                    outlined
                    dense
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedProperty.startDate"
                  no-title
                  scrollable
                  @input="selectedProperty.startDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" md="6">
              <v-menu
                v-model="selectedProperty.endDateMenu"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedProperty.endDate"
                    hide-details
                    label="End Date"
                    v-bind="attrs"
                    readonly
                    outlined
                    dense
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedProperty.endDate"
                  no-title
                  scrollable
                  @input="selectedProperty.endDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="selectedProperty.userLimit"
                label="Property Manager Limit"
                prepend-inner-icon="mdi-account-question"
                hide-details
                required
                dense
                outlined
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="selectedProperty.unitLimit"
                label="Unit Limit"
                prepend-inner-icon="mdi-office-building"
                required
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="selectedProperty.sendEmail"
                hide-details
                label="Email Notifications"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="selectedProperty.sendSMS"
                hide-details
                label="SMS Notifications"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="selectedProperty.payOnline"
                hide-details
                label="Online Payment"
              ></v-switch>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              :disabled="loading"
              @click="approveProperty"
              >Update</v-btn
            >
            <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="userDialog"
      :max-width="options.width"
      @keydown.esc="cancel"
    >
      <v-card>
        <p class="subtitle-1 font-weight-bold px-10 pt-8 mb-0">Update User</p>
        <v-container class="px-10">
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="6">
              <v-menu
                v-model="selectedUser.startDateMenu"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedUser.subscriptionStart"
                    hide-details
                    label="Start Date"
                    v-bind="attrs"
                    readonly
                    outlined
                    dense
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedUser.subscriptionStart"
                  no-title
                  scrollable
                  @input="selectedUser.startDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" md="6">
              <v-menu
                v-model="selectedUser.endDateMenu"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedUser.subscriptionEnd"
                    hide-details
                    label="End Date"
                    v-bind="attrs"
                    readonly
                    outlined
                    dense
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedUser.subscriptionEnd"
                  no-title
                  scrollable
                  @input="selectedUser.endDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-switch
                v-model="selectedUser.updateAllProperties"
                hide-details
                label="Update All Properties"
              >
              </v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="selectedUser.unitLimit"
                label="Unit Limit"
                prepend-inner-icon="mdi-office-building"
                required
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="selectedUser.propertyLimit"
                label="Property Limit"
                prepend-inner-icon="mdi-office-building"
                required
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="selectedUser.status"
                :items="userStatuses"
                label="Status"
                hide-details
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="selectedUser.sendEmail"
                hide-details
                label="Email Notifications"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="selectedUser.sendSMS"
                hide-details
                label="SMS Notifications"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="selectedUser.payOnline"
                hide-details
                label="Online Payment"
              ></v-switch>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              :disabled="loading"
              @click="updateUser"
              >Update</v-btn
            >
            <v-btn color="grey darken-1" text @click="cancelUser">Cancel</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { dayjs } from '../util/date'

export default {
  data() {
    return {
      lessors: [],
      searchLessorsList: '',
      username: '',
      user: {},
      selectedProperties: [],
      dialog: false,
      userDialog: false,
      options: {
        color: 'primary',
        width: 500
        // zIndex: 200
      },
      selectedProperty: {
        propertyId: null,
        startDate: dayjs()
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format('YYYY-MM-DD'),
        endDate: dayjs()
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .add(1, 'year')
          .format('YYYY-MM-DD'),
        // startDatePicker: dayjs().hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD'),
        // endDatePicker: dayjs().hour(0).minute(0).second(0).millisecond(0).add(1, 'year').format('YYYY-MM-DD'),
        startDateMenu: false,
        endDateMenu: false,
        userLimit: 1,
        unitLimit: 0,
        sendEmail: false,
        sendSMS: false,
        payOnline: false
      },
      selectedUser: {
        userId: null,
        subscriptionStart: dayjs()
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format('YYYY-MM-DD'),
        subscriptionEnd: dayjs()
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .add(1, 'year')
          .format('YYYY-MM-DD'),
        // startDatePicker: dayjs().hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD'),
        // endDatePicker: dayjs().hour(0).minute(0).second(0).millisecond(0).add(1, 'year').format('YYYY-MM-DD'),
        startDateMenu: false,
        endDateMenu: false,
        unitLimit: 0,
        propertyLimit: 0,
        sendEmail: false,
        sendSMS: false,
        payOnline: false,
        updateAllProperties: true,
        status: 'pending'
      },
      userStatuses: ['ok', 'pending', 'temporary', 'reserved', 'subscribed'],
      lessorsEmail: '',
      snackbar: false,
      snackbarMessage: '',
      loading: true
    }
  },
  async mounted() {
    let lessors = await this.$store.dispatch('users/fetchLessorsAction')
    this.lessors = lessors.map((l) => {
      return {
        value: l,
        text: l.username
      }
    })
    this.lessorsEmail = lessors.map((l) => l.email1)
    this.loading = false
  },
  methods: {
    getProperty: async function () {
      this.loading = true
      await this.$store.dispatch('properties/fetchSelectedPropertiesAction', {
        userId: this.user.userId
      })
      this.selectedProperties =
        this.$store.getters['properties/getSelectedProperties']
      this.loading = false
    },
    approveProperty: function () {
      this.loading = true
      this.$store
        .dispatch('properties/approvePropertyAction', {
          propertyId: this.selectedProperty.propertyId,
          startDate: dayjs(this.selectedProperty.startDate).format(),
          endDate: dayjs(this.selectedProperty.endDate).format(),
          userLimit: this.selectedProperty.userLimit,
          unitLimit: this.selectedProperty.unitLimit,
          sendEmail: this.selectedProperty.sendEmail,
          sendSMS: this.selectedProperty.sendSMS,
          payOnline: this.selectedProperty.payOnline
        })
        .then(() => {
          this.dialog = false
          this.getProperty()
          this.loading = false
        })
    },
    cancel: function () {
      this.dialog = false
    },
    propertyDialog(selectedProperty) {
      this.dialog = true
      this.selectedProperty.propertyId = selectedProperty.propertyId
      this.selectedProperty.startDate = dayjs(
        selectedProperty.subscriptionStart
      ).format('YYYY-MM-DD')
      // this.selectedProperty.startDatePicker = dayjs(selectedProperty.subscriptionStart).format('YYYY-MM-DD')
      this.selectedProperty.endDate = dayjs(
        selectedProperty.subscriptionEnd
      ).format('YYYY-MM-DD')
      // this.selectedProperty.endDatePicker = dayjs(selectedProperty.subscriptionEnd).format('YYYY-MM-DD')
      this.selectedProperty.userLimit = selectedProperty.userLimit
      // this.selectedProperty.unitLimit = selectedProperty.unitLimit
      this.selectedProperty.sendEmail = selectedProperty.sendEmail
      this.selectedProperty.sendSMS = selectedProperty.sendSMS
      this.selectedProperty.payOnline = selectedProperty.payOnline
    },
    parseSubscriptionPeriod(s1, s2) {
      return `${dayjs(s1).format('MMMM DD, YYYY')} - ${dayjs(s2).format(
        'MMMM DD, YYYY'
      )}`
    },
    parseDate(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },
    activateUserDialog() {
      this.selectedUser = this.user
      this.selectedUser.subscriptionStart = dayjs(
        this.selectedUser.subscriptionStart
      ).format('YYYY-MM-DD')
      this.selectedUser.subscriptionEnd = dayjs(
        this.selectedUser.subscriptionEnd
      ).format('YYYY-MM-DD')
      // this.selectedUser.startDatePicker = dayjs(this.selectedUser.subscriptionStart).format('YYYY-MM-DD')
      // this.selectedUser.endDatePicker = dayjs(this.selectedUser.subscriptionEnd).format('YYYY-MM-DD')
      this.userDialog = true
    },
    updateUser() {
      this.loading = true
      // format selected user dates
      this.selectedUser.subscriptionStart = dayjs(
        this.selectedUser.subscriptionStart
      ).format()
      this.selectedUser.subscriptionEnd = dayjs(
        this.selectedUser.subscriptionEnd
      ).format()

      this.$store
        .dispatch('users/updateUserAction', this.selectedUser)
        .then(() => {
          this.userDialog = false
          this.getProperty()
          this.loading = false
        })
    },
    cancelUser() {
      this.userDialog = false
    },
    getRoleInProperty(property, user) {
      const propertyUser = property.users.find((u) => u.userId == user.userId)
      return propertyUser && propertyUser.role
    },
    copyEmail() {
      let testingCodeToCopy = document.querySelector('#emails')
      testingCodeToCopy.setAttribute('type', 'text') // 不是 hidden 才能複製
      testingCodeToCopy.select()

      try {
        document.execCommand('copy')
        this.snackbarMessage = 'Email addresses copied to clipboard!'
        this.snackbar = true
      } catch (err) {
        this.snackbarMessage = 'Unable to copy email addresses'
        this.snackbar = true
      }
    }
  }
}
</script>

<style scoped>
p {
  padding-bottom: 10px;
}
.container {
  width: auto;
}
.container.main-container {
  min-height: 100vh;
}
.v-card {
  border-radius: 12px !important;
}
</style>
